import React from 'react';
import {BaixarNFEButton} from "./BaixarNFEButton";

const SCHEMA_NAME = 'dinamica_sefaz_nfe';


export const DinamicaSefazNfeCustomSchema = (name, schema) => {
    console.log('Customizando user list schema', name, schema)
    if (!(name === SCHEMA_NAME)) {
        return;
    }

    schema.header.customButtons = <BaixarNFEButton/>

    return schema;

}



